import React, { useEffect } from 'react';
import { node } from 'prop-types';
import { useHelmet, TitleTag, MetaTag, LinkTag } from '@thd-nucleus/thd-helmet';

const HD_URL = 'https://www.homedepot.com';

const metadataHandler = ({ props }) => {
  const tags = [];
  const { data, title = '', description = '' } = props;
  const dataKeys = data && Object.keys(data);

  if (title) tags.push(new TitleTag(title));
  if (description) tags.push(new MetaTag({ name: 'description', content: description, id: 'prop-description' }));

  if (!dataKeys?.length) return tags;

  dataKeys.forEach((tag) => {
    const content = data[tag] || '';
    let hrefLang;
    if (tag === '__typename') {
      return;
    }
    if (tag === 'canonicalURL') {
      tags.push(new MetaTag({ property: 'og:url', content: `${HD_URL}${content}`, id: tag }));
    } else if (tag === 'siteName') {
      tags.push(new MetaTag({ property: 'og:site_name', content, id: tag }));
    } else if (tag === 'ogDescription') {
      tags.push(new MetaTag({ property: 'og:description', content, id: 'thd-helmet__meta--description' }));
    } else if (tag === 'ogTitle') {
      tags.push(new MetaTag({ property: 'og:title', content, id: 'thd-helmet__meta--title' }));
    } else if (tag === 'facebookAdmins') {
      tags.push(new MetaTag({ property: 'fb:admins', content, id: tag }));
    } else if (tag.includes('alternateUrl')) {
      const langSubString1 = tag.substr(12, 2).toLowerCase();
      const langSubString2 = tag.substr(14, 2).toLowerCase() ? `-${tag.substr(14, 2).toLowerCase()}` : '';
      hrefLang = `${langSubString1}${langSubString2}`;
      tags.push(new LinkTag({ rel: 'alternate', href: content, 'href-lang': hrefLang, id: `alternate-${hrefLang}` }));
    } else if (tag === 'robots') {
      tags.push(new MetaTag({ name: 'robots', content, id: 'robots' }));
    } else if (tag === 'mobile') {
      tags.push(new LinkTag({ rel: 'alternate', href: content, id: tag }));
    } else {
      tags.push(new MetaTag({ property: `og:${tag}`, content, id: tag }));
    }
  });

  tags.push(new TitleTag(data.title));
  tags.push(new MetaTag({ name: 'description', content: data.description || '', id: 'data-description' }));
  tags.push(new LinkTag({ rel: 'canonical', href: `${HD_URL}${data.canonicalURL || ''}`, id: 'canonical' }));

  return tags;
};

const Metadata = (props) => {
  const { children } = props;

  useHelmet('rootMetadataHandler', { props }, metadataHandler, [props]);
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('metadata.ready'); }, []);

  return (
    children || null
  );
};

Metadata.propTypes = {
  children: node,
};

Metadata.defaultProps = {
  children: null,
};

export { Metadata };
